import React, { useState, useEffect } from "react";
import { graphql, createPaginationContainer } from "react-relay";
import "./PostView.css";
import { timeDifferenceForDate } from "../utils";
import { ITEMS_PER_PAGE } from "../constants";
import { useNavigate } from "react-router-dom";
import { commitLocalUpdate } from "react-relay";
import environment from "../Environment";
import PopupMenu from "../components/PopupMenu";
import BookmarkViewContainer from "./BookmarkViewContainer";
import PostNoteViewContainer from "./PostNoteViewContainer";
import { InputModal } from "./Modal";
import FullSpanInputModal from "./FullSpanInputModal";

import DetailViewModal from "./DetailViewModal";
import { useTheme, useThemeUpdate } from "../contexts/ThemeContext";
import { useMediaQuery } from "react-responsive";
// import GettingStarted from "./GettingStarted";
// import BaseLoader from "../components/BaseLoader";
import Spinner from "../Spinner";
import introIllustration from "../backgrounds/intro-image.png";
import emptyIllustration from "../backgrounds/empty-feed.png";
import RightNav from "../components/RightNav";
import PostGrid from "../components/PostGrid";
import PostMagazine from "./PostMagazine";
import PostList from "./PostList";
// import YouTube from "react-youtube";
// import CategoryGrid from "./CategoryGrid";

const IntroPost = (props) => {
    const navigate = useNavigate();
    function onAddFeedButtonClick(e) {
        e.preventDefault();
        navigate("/add-source");
    }
    return (
        <div className="video-container">
            <div className="info-container box">
                <div className="video-desc">
                    <img alt="" src={introIllustration} width="300" />
                    <button
                        onClick={onAddFeedButtonClick}
                        className="standard-action-button"
                    >
                        {" "}
                        Add Feeds{" "}
                    </button>
                </div>
            </div>
        </div>
    );
};

const EmptyPost = (props) => {
    return (
        <div className="video-container">
            <div className="info-container box">
                <div className="video-desc">
                    <img alt="" src={emptyIllustration} width="300" />
                    <span className="highlight">
                        <h2>It seems like your feeds are empty!!</h2>
                    </span>
                </div>
            </div>
        </div>
    );
};

function PostView(props) {
    const [articleMenuActive, setArticleMenuActive] = useState(false);
    const [isDetailView, setIsDetailView] = useState(false);
    const navigate = useNavigate();
    const { selectedPosts } = props.home_Feeds;
    const [isDetailModalActive, setIsDetailModalActive] = useState(false);
    const [postTitle, setPostTitle] = useState("");
    const [postBody, setPostBody] = useState("");
    const [postId, setPostId] = useState("");
    const [postLink, setPostLink] = useState("");
    const [postImageURL, setPostImageURL] = useState("");
    const [postBodyHtml, setPostBodyHtml] = useState("");
    const [postCreated, setPostCreated] = useState("");
    const [sourceName, setSourceName] = useState("");
    const [isModalActive, setIsModalActive] = useState(false);

    const user = props.user;
    const { first_time_user } = props.user;
    const settings = props.settings;
    const {
        isBookmarkView,
        view,
        isPostNoteView,
        selectedNodeId,
        isFullSpanInputModalActivated,
        isRightNavActivated,
    } = props.settings;
    const theme = useTheme();
    const setTheme = useThemeUpdate();
    const isSmallScreen = useMediaQuery({
        query: "(max-width: 1370px)",
    });

    useEffect(() => {
        if (!isSmallScreen) {
            window.addEventListener("scroll", handleScroll);
        }
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    function _loadMore() {
        if (!props.relay.hasMore()) {
            return;
        } else if (props.relay.isLoading()) {
            return;
        }
        props.relay.loadMore(ITEMS_PER_PAGE);
    }

    function onLoadMoreButtonClick(e) {
        e.preventDefault();
        _loadMore();
    }

    const handleScroll = (e) => {
        e.preventDefault();

        if (
            window.innerHeight + document.documentElement.scrollTop ===
            document.documentElement.offsetHeight
        ) {
            _loadMore();
        }
    };

    function setSeletedPost(id) {
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(id, "selectedPostId");
        });
    }

    function onAddFolderButtonClick(e) {
        e.preventDefault();
        if (!isSmallScreen) {
            setIsModalActive(true);
        } else {
            commitLocalUpdate(environment, (store) => {
                const record = store.getRoot().getLinkedRecord("settings");
                record.setValue(true, "isFullSpanInputModalActivated");
            });
        }
    }
    function onHeadlineClick(e) {
        e.preventDefault();
        setIsDetailView(true);
        setIsDetailModalActive(true);
        setPostBody(e.target.dataset.body);
        setPostTitle(e.target.dataset.title);
        setPostLink(e.target.dataset.link);
        setPostId(e.target.dataset.postid);
        setPostImageURL(e.target.dataset.img);
        setPostBodyHtml(e.target.dataset.html);
        setPostCreated(e.target.dataset.created);
        setSourceName(e.target.dataset.source);

        // let scroll = window.scrollY;

        // commitLocalUpdate(environment, store => {
        // 	const record = store.getRoot().getLinkedRecord("settings");
        // 	record.setValue(scroll.toString(), "scrollPosition");
        // });

        // router.push("/home/detail-view");
        setSeletedPost(e.target.dataset.id);
    }

    function onDetailViewClick(e) {
        setIsDetailView(false);
    }

    return (
        <div id={`main-news-container news-container-${isDetailView}`}>
            {isDetailModalActive ? (
                <div>
                    <DetailViewModal
                        title=""
                        isModalActive={isDetailModalActive}
                        setIsModalActive={setIsDetailModalActive}
                        isDetailView={false}
                        postId={postId}
                        postLink={postLink}
                        postTitle={postTitle}
                        postBody={postBody}
                        postBodyHtml={postBodyHtml}
                        postImageURL={postImageURL}
                        sourceName={sourceName}
                        postCreated={postCreated}
                        user={user}
                        settings={settings}
                    />
                </div>
            ) : null}
            {isBookmarkView ? (
                <BookmarkViewContainer user={user} settings={settings} />
            ) : (
                <div className={`news-container-wrapper`}>
                    {isPostNoteView ? (
                        <PostNoteViewContainer
                            user={user}
                            settings={settings}
                        />
                    ) : (
                        <div>
                            {selectedPosts.edges.length == 0 ? (
                                <>
                                    {first_time_user ? (
                                        <IntroPost
                                            onAddFolderButtonClick={
                                                onAddFolderButtonClick
                                            }
                                        />
                                    ) : (
                                        <EmptyPost />
                                    )}
                                </>
                            ) : (
                                <>
                                    {view === "grid" ? (
                                        <PostGrid
                                            settings={settings}
                                            user={user}
                                            onHeadlineClick={onHeadlineClick}
                                            selectedPosts={selectedPosts}
                                            articleMenuActive={
                                                articleMenuActive
                                            }
                                        />
                                    ) : (
                                        <>
                                            {view === "magazine" ? (
                                                <PostMagazine
                                                    settings={settings}
                                                    user={user}
                                                    onHeadlineClick={
                                                        onHeadlineClick
                                                    }
                                                    selectedPosts={
                                                        selectedPosts
                                                    }
                                                    articleMenuActive={
                                                        articleMenuActive
                                                    }
                                                />
                                            ) : null}
                                        </>
                                    )}
                                </>
                            )}
                            {selectedPosts.edges.length !== 0 ? (
                                <RightNav
                                    isActivated={isRightNavActivated}
                                    user={user}
                                    settings={props.settings}
                                />
                            ) : null}
                        </div>
                    )}

                    {isSmallScreen ? (
                        <div>
                            {isFullSpanInputModalActivated ? (
                                <FullSpanInputModal
                                    isModalActive={true}
                                    user={user}
                                    settings={settings}
                                />
                            ) : null}
                        </div>
                    ) : (
                        <div>
                            {isModalActive ? (
                                <div>
                                    <InputModal
                                        title="Create a new folder"
                                        setIsModalActive={setIsModalActive}
                                        isModalActive={isModalActive}
                                    />
                                </div>
                            ) : null}
                        </div>
                    )}

                    {/* {isModalActive ? (
            <div>
              {isSmallScreen ? (
                <div className={`fullspan-input-modal-component`}>
                  <InputModalComponent />
                </div>
              ) : (
                <div>
                  <InputModal
                    title="Create a new folder"
                    setIsModalActive={setIsModalActive}
                    isModalActive={isModalActive}
                  />
                </div>
              )}
            </div>
          ) : null} */}
                    <div className={`load-more-button-container`}>
                        {isSmallScreen && props.relay.hasMore() ? (
                            <div>
                                {!props.relay.isLoading() ? (
                                    <div>
                                        <button
                                            onClick={onLoadMoreButtonClick}
                                            className={`load-more-button`}
                                        >
                                            Load More
                                        </button>
                                    </div>
                                ) : (
                                    <Spinner isLoading={true} />
                                )}
                            </div>
                        ) : null}
                    </div>

                    <div>
                        {props.relay.isLoading() ? (
                            <div>
                                <Spinner isLoading={true} />
                            </div>
                        ) : null}
                    </div>
                </div>
            )}
        </div>
    );
}

export default createPaginationContainer(
    PostView,
    {
        home_Feeds: graphql`
            fragment PostView_home_Feeds on Query {
                selectedPosts(
                    source_In: $source_In
                    searchTerms: $searchTerms
                    first: $count
                    after: $after
                    orderBy: $orderBy
                    filterTerms: $filterTerms
                    isAdvancedSearch: $isAdvancedSearch
                    hasPhrase: $hasPhrase
                    withWords: $withWords
                    withoutWords: $withoutWords
                    searchScope: $searchScope
                    searchTime: $searchTime
                    allSubscriptions: $allSubscriptions
                    selectedSentimentPostIds: $selectedSentimentPostIds
                ) @connection(key: "PostView_selectedPosts") {
                    edges {
                        node {
                            id
                            title
                            created
                            found
                            body
                            body_short
                            body_html
                            link
                            image_url
                            source {
                                id
                                name
                                edited_name
                            }
                        }
                    }
                    pageInfo {
                        hasNextPage
                        endCursor
                    }
                }
            }
        `,
    },
    {
        direction: "forward",
        query: graphql`
            query PostViewForwardQuery(
                $source_In: [ID]
                $searchTerms: [String]
                $orderBy: [String]
                $count: Int!
                $after: String
                $filterTerms: [String]
                $isAdvancedSearch: Boolean
                $hasPhrase: String
                $withWords: String
                $withoutWords: String
                $searchScope: String
                $searchTime: String
                $allSubscriptions: Boolean
                $selectedSentimentPostIds: [ID]
            ) {
                ...PostView_home_Feeds
            }
        `,
        getConnectionFromProps(props) {
            return props.home_Feeds && props.home_Feeds.selectedPosts;
        },
        getFragmentVariables(previousVariables, totalCount) {
            return {
                ...previousVariables,
                count: totalCount,
            };
        },
        getVariables(props, paginationInfo, fragmentVariables) {
            return {
                count: paginationInfo.count,
                after: paginationInfo.cursor,
                source_In: fragmentVariables.source_In,
                searchTerms: fragmentVariables.searchTerms,
                orderBy: fragmentVariables.orderBy,
                filterTerms: fragmentVariables.filterTerms,
                isAdvancedSearch: fragmentVariables.isAdvancedSearch,
                hasPhrase: fragmentVariables.hasPhrase,
                withWords: fragmentVariables.withWords,
                withoutWords: fragmentVariables.withoutWords,
                searchScope: fragmentVariables.searchScope,
                searchTime: fragmentVariables.searchTime,
                allSubscriptions: fragmentVariables.allSubscriptions,
                selectedSentimentPostIds:
                    fragmentVariables.selectedSentimentPostIds,
            };
        },
    }
);
